/**
 * お支払い情報更新のためのメールを送信する責務を担う
 */
import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useFetch } from '../common/useFetch';
import { useEmitMessage } from '../common/useEmitMessage';
import { SubscriptionState } from '../App/useSubscription';

export const useUpdatePaymentMethod = (
  subscription: SubscriptionState,
  token: string
): UseUpdateUpdatePaymentMethod => {

  const history = useHistory();
  const emitMessage = useEmitMessage();

  const success = () => {
    history.push('/paymentMethod/complete');
    emitMessage('app-complete');
  };
  const failed = () => emitMessage('app-error', 'keep');

  const [updatePaymentMethodState, callUpdatePaymentMethod] = 
    useFetch('paymentMethodUpdate', token, success, failed);

  const updatePaymentMethod = useCallback(() => {
    if (!subscription?.subscriptionContractId) return;
    callUpdatePaymentMethod({ 
      subscriptionId: subscription.subscriptionContractId 
    });
  }, [subscription]);

  // 通信開始時メッセージ出力
  useEffect(() => {
    if (updatePaymentMethodState.loading === true)
      emitMessage('app-updating-payment', 'keep');
  }, [updatePaymentMethodState]);

  return [ updatePaymentMethodState.loading, updatePaymentMethod ];
}

// types

type UseUpdateUpdatePaymentMethod = [
  boolean,
  () => void
]